<mat-button-toggle-group (change)="onChange($event.value)"
                         [class.compact]="compact"
                         [class.flex-wrap]="!compact"
                         [class.gap-5]="!compact"
                         [class.mb-0]="compact"
                         [formControl]="control"
                         class="customToggleGroup w-content">
    <mat-button-toggle *ngFor="let option of options"
                       [style.background-color]="getColour(option.label, option.value)? getColour(option.label, option.value): null"
                       [style.color]="this.themeService.getReadableColor(getColour(option.label, option.value))"
                       [value]="option.value">
        <mat-icon *ngIf="option.icon">{{ option.icon }}</mat-icon>
        {{ option.label }}
    </mat-button-toggle>
</mat-button-toggle-group>
